<template>
  <div class="profile-page">
    <div class="background-ellipse"></div>
    <div class="profile-info">
      <!-- 个人信息卡片 -->
      <div class="profile-card">
        <div class="avatar">
          <img class="icon" v-if="userInfo.iconUrl" :src="userInfo.iconUrl" alt="头像" />
          <yq-icon class="icon" name="user" v-else/>
        </div>
        <div class="info">
          <p class="name">
            <ww-open-data type="userName" :openid="userInfo.qywxOpenId" />
          </p>
          <p class="phone">{{ userInfo.userPhone }}</p>
          <p class="role">{{ userInfo.roleName }}</p>
        </div>
      </div>
      <div class="profile-card">
        <data-column @click="router.push(`/qywx/mine/setting`)">
          <template #label>
            <yq-icon name="element-ui_user" class="icon-primary icon-left"/>个人信息
          </template>
          <yq-icon name="element-ui_arrow-right" class="icon-primary"/>
        </data-column>
        <data-column @click="router.push(`/qywx/mine/password`)">
          <template #label>
            <yq-icon name="element-ui_lock" class="icon-primary icon-left"/>修改密码
          </template>
          <yq-icon name="element-ui_arrow-right" class="icon-primary"/>
        </data-column>
      </div>
      <div class="profile-card">
        <data-column @click="closeApp">
          <template #label>
            <yq-icon name="element-ui_switch-button" class="icon-primary icon-left" style="color: var(--el-color-danger)"/>退出系统
          </template>
        </data-column>
      </div>
      <!-- 系统版本信息 -->
      <div class="version-info">
        <p>系统版本: {{ systemVersion }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import util from "@/util/util";
import YqIcon from "@/components/YqIcon.vue";
import qywxUtil from "@/util/qywxUtil";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import {useRoute, useRouter} from "vue-router";
export default {
  name: "ProfilePage",
  components: {DataColumn, YqIcon},
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  data() {
    return {
      // 系统版本信息
      systemVersion: "v1.1.0",
      userInfo: {
        iconUrl: "",
        merchantName: "",
        roleName: "",
        userName: "",
        userPhone: "",
      }
    };
  },
  created() {
    qywxUtil.ready().then(() => {
      qywxUtil.initOpenData().then((res) => {
        console.log("注册通讯录组件成功", res);
        // 聊天记录组件
        util.getUserInfo().then(user => {
          this.userInfo = user;
          this.$nextTick().then(() => {
            qywxUtil.bindQywxName();
          })
        });
      });
    });

  },
  methods: {
    closeApp() {
      alert("关闭系统")
      window.close();
      window.open("about:blank", "_top").close();
    }
  }
};
</script>

<style scoped>
/* 页面整体样式 */
.profile-page {
  font-family: Arial, sans-serif;
  padding: 20px;
  .background-ellipse{
    width: 200%;
    aspect-ratio: 1/1;
    background: linear-gradient(180deg, #FFF 60%, var(--el-color-primary));
    border-radius: 50%;
    position: absolute;
    left: -50%;
    bottom: calc(100vh - 250px);
    z-index: 0;
  }
  .profile-info{
    position: relative;
    z-index: 1;
    /* 个人信息卡片样式 */
    .profile-card {
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      padding: 20px;
      margin-top: 20px;
      position: relative;
      &:first-child{
        margin-top: 80px;
        padding-top: 80px;
        text-align: center;
        height: 100px;
      }
      /* 头部样式 */
      .avatar{
        width: 100%;
        text-align: center;
        position: absolute;
        left: 0;
        top: -60px;
        .icon {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: var(--yq-background-color);
          font-size: 40px;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--yq-border-color);
        }
      }
      .info{
        .name {
          font-size: 20px;
          font-weight: bold;
          color: #333;
          margin: 0;
        }
        .phone,.role {
          font-size: 16px;
          color: #666;
          margin: 5px 0 0;
        }
      }
      .icon-primary{
        color: var(--el-color-primary);
        font-size: var(--yq-font-size-large-mobile);
        font-weight: 600;
      }
      .icon-left{
        margin-right: 10px;
      }
    }
    /* 版本信息样式 */
    .version-info {
      text-align: center;
      color: #999;
      font-size: 14px;
    }
  }

}
</style>
